/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfEvent } from '../models';
// @ts-ignore
import type { BfManagedEvent } from '../models';
// @ts-ignore
import type { BfManagedSource } from '../models';
// @ts-ignore
import type { BfSourceProcess } from '../models';
// @ts-ignore
import type { FeatureCollectionBfEvent } from '../models';
/**
 * ManagementApi - axios parameter creator
 */
export const ManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Copies everything from the other event into the new managed event
         * @summary Create from another event, but copy it
         * @param {string} eHash Hash to copy from
         * @param {BfSourceProcess} destinationProcess Process which will own the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManagedEventCopy: async (eHash: string, destinationProcess: BfSourceProcess, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eHash' is not null or undefined
            assertParamExists('createManagedEventCopy', 'eHash', eHash)
            // verify required parameter 'destinationProcess' is not null or undefined
            assertParamExists('createManagedEventCopy', 'destinationProcess', destinationProcess)
            const localVarPath = `/v1/management/event/copy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (eHash !== undefined) {
                localVarQueryParameter['eHash'] = eHash;
            }

            if (destinationProcess !== undefined) {
                localVarQueryParameter['destinationProcess'] = destinationProcess;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Load the provided JSON as a managed event
         * @summary Create a managed event manually
         * @param {BfManagedEvent} bfManagedEvent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManagedEventManual: async (bfManagedEvent: BfManagedEvent, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfManagedEvent' is not null or undefined
            assertParamExists('createManagedEventManual', 'bfManagedEvent', bfManagedEvent)
            const localVarPath = `/v1/management/event/manual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfManagedEvent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Copies everything from the other event into the new managed event, and hide the original
         * @summary Create from another event, but mask it
         * @param {string} eHash Hash to copy from
         * @param {BfSourceProcess} sourceProcess Process which owns the event
         * @param {BfSourceProcess} destinationProcess Process which will own the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManagedEventMask: async (eHash: string, sourceProcess: BfSourceProcess, destinationProcess: BfSourceProcess, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eHash' is not null or undefined
            assertParamExists('createManagedEventMask', 'eHash', eHash)
            // verify required parameter 'sourceProcess' is not null or undefined
            assertParamExists('createManagedEventMask', 'sourceProcess', sourceProcess)
            // verify required parameter 'destinationProcess' is not null or undefined
            assertParamExists('createManagedEventMask', 'destinationProcess', destinationProcess)
            const localVarPath = `/v1/management/event/mask`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (eHash !== undefined) {
                localVarQueryParameter['eHash'] = eHash;
            }

            if (sourceProcess !== undefined) {
                localVarQueryParameter['sourceProcess'] = sourceProcess;
            }

            if (destinationProcess !== undefined) {
                localVarQueryParameter['destinationProcess'] = destinationProcess;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List events for a source process
         * @summary Events for source process
         * @param {BfSourceProcess} source Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentEventsForSource: async (source: BfSourceProcess, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('currentEventsForSource', 'source', source)
            const localVarPath = `/v1/management/current/{source}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a managed event
         * @summary Remove a managed event
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManagedEvent: async (eKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eKey' is not null or undefined
            assertParamExists('deleteManagedEvent', 'eKey', eKey)
            const localVarPath = `/v1/management/event/{e_key}`
                .replace(`{${"e_key"}}`, encodeURIComponent(String(eKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List active events for a source process
         * @summary Active events for source process
         * @param {BfSourceProcess} source Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveManagedEventsForSource: async (source: BfSourceProcess, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('getActiveManagedEventsForSource', 'source', source)
            const localVarPath = `/v1/management/active/{source}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current state of the managed event
         * @summary Get a managed event
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagedEvent: async (eKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eKey' is not null or undefined
            assertParamExists('getManagedEvent', 'eKey', eKey)
            const localVarPath = `/v1/management/event/{e_key}`
                .replace(`{${"e_key"}}`, encodeURIComponent(String(eKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List managed events for a source process
         * @summary Get managed events for source process
         * @param {BfSourceProcess} source Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagedEventsForSource: async (source: BfSourceProcess, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('getManagedEventsForSource', 'source', source)
            const localVarPath = `/v1/management/events/{source}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Preview the data for a source process
         * @summary Get preview events for source process
         * @param {BfSourceProcess} source Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewManagedEventsForSource: async (source: BfSourceProcess, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('getPreviewManagedEventsForSource', 'source', source)
            const localVarPath = `/v1/management/preview/{source}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List source processes which can be managed
         * @summary List source processes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listManageableSources: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/management/sources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a managed event with the new definition
         * @summary Update a managed event
         * @param {BfManagedEvent} bfManagedEvent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManagedEvent: async (bfManagedEvent: BfManagedEvent, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfManagedEvent' is not null or undefined
            assertParamExists('updateManagedEvent', 'bfManagedEvent', bfManagedEvent)
            const localVarPath = `/v1/management/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfManagedEvent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManagementApi - functional programming interface
 */
export const ManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Copies everything from the other event into the new managed event
         * @summary Create from another event, but copy it
         * @param {string} eHash Hash to copy from
         * @param {BfSourceProcess} destinationProcess Process which will own the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManagedEventCopy(eHash: string, destinationProcess: BfSourceProcess, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManagedEventCopy(eHash, destinationProcess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.createManagedEventCopy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Load the provided JSON as a managed event
         * @summary Create a managed event manually
         * @param {BfManagedEvent} bfManagedEvent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManagedEventManual(bfManagedEvent: BfManagedEvent, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManagedEventManual(bfManagedEvent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.createManagedEventManual']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Copies everything from the other event into the new managed event, and hide the original
         * @summary Create from another event, but mask it
         * @param {string} eHash Hash to copy from
         * @param {BfSourceProcess} sourceProcess Process which owns the event
         * @param {BfSourceProcess} destinationProcess Process which will own the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManagedEventMask(eHash: string, sourceProcess: BfSourceProcess, destinationProcess: BfSourceProcess, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManagedEventMask(eHash, sourceProcess, destinationProcess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.createManagedEventMask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List events for a source process
         * @summary Events for source process
         * @param {BfSourceProcess} source Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currentEventsForSource(source: BfSourceProcess, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfEvent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currentEventsForSource(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.currentEventsForSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a managed event
         * @summary Remove a managed event
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteManagedEvent(eKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteManagedEvent(eKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.deleteManagedEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List active events for a source process
         * @summary Active events for source process
         * @param {BfSourceProcess} source Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveManagedEventsForSource(source: BfSourceProcess, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfManagedEvent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveManagedEventsForSource(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getActiveManagedEventsForSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the current state of the managed event
         * @summary Get a managed event
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManagedEvent(eKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfManagedEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManagedEvent(eKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getManagedEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List managed events for a source process
         * @summary Get managed events for source process
         * @param {BfSourceProcess} source Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManagedEventsForSource(source: BfSourceProcess, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfManagedEvent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManagedEventsForSource(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getManagedEventsForSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Preview the data for a source process
         * @summary Get preview events for source process
         * @param {BfSourceProcess} source Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreviewManagedEventsForSource(source: BfSourceProcess, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureCollectionBfEvent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreviewManagedEventsForSource(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getPreviewManagedEventsForSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List source processes which can be managed
         * @summary List source processes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listManageableSources(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfManagedSource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listManageableSources(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.listManageableSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a managed event with the new definition
         * @summary Update a managed event
         * @param {BfManagedEvent} bfManagedEvent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateManagedEvent(bfManagedEvent: BfManagedEvent, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateManagedEvent(bfManagedEvent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.updateManagedEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ManagementApi - factory interface
 */
export const ManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManagementApiFp(configuration)
    return {
        /**
         * Copies everything from the other event into the new managed event
         * @summary Create from another event, but copy it
         * @param {string} eHash Hash to copy from
         * @param {BfSourceProcess} destinationProcess Process which will own the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManagedEventCopy(eHash: string, destinationProcess: BfSourceProcess, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createManagedEventCopy(eHash, destinationProcess, options).then((request) => request(axios, basePath));
        },
        /**
         * Load the provided JSON as a managed event
         * @summary Create a managed event manually
         * @param {BfManagedEvent} bfManagedEvent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManagedEventManual(bfManagedEvent: BfManagedEvent, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createManagedEventManual(bfManagedEvent, options).then((request) => request(axios, basePath));
        },
        /**
         * Copies everything from the other event into the new managed event, and hide the original
         * @summary Create from another event, but mask it
         * @param {string} eHash Hash to copy from
         * @param {BfSourceProcess} sourceProcess Process which owns the event
         * @param {BfSourceProcess} destinationProcess Process which will own the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManagedEventMask(eHash: string, sourceProcess: BfSourceProcess, destinationProcess: BfSourceProcess, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createManagedEventMask(eHash, sourceProcess, destinationProcess, options).then((request) => request(axios, basePath));
        },
        /**
         * List events for a source process
         * @summary Events for source process
         * @param {BfSourceProcess} source Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentEventsForSource(source: BfSourceProcess, options?: RawAxiosRequestConfig): AxiosPromise<Array<BfEvent>> {
            return localVarFp.currentEventsForSource(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a managed event
         * @summary Remove a managed event
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManagedEvent(eKey: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteManagedEvent(eKey, options).then((request) => request(axios, basePath));
        },
        /**
         * List active events for a source process
         * @summary Active events for source process
         * @param {BfSourceProcess} source Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveManagedEventsForSource(source: BfSourceProcess, options?: RawAxiosRequestConfig): AxiosPromise<Array<BfManagedEvent>> {
            return localVarFp.getActiveManagedEventsForSource(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current state of the managed event
         * @summary Get a managed event
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagedEvent(eKey: string, options?: RawAxiosRequestConfig): AxiosPromise<BfManagedEvent> {
            return localVarFp.getManagedEvent(eKey, options).then((request) => request(axios, basePath));
        },
        /**
         * List managed events for a source process
         * @summary Get managed events for source process
         * @param {BfSourceProcess} source Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagedEventsForSource(source: BfSourceProcess, options?: RawAxiosRequestConfig): AxiosPromise<Array<BfManagedEvent>> {
            return localVarFp.getManagedEventsForSource(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Preview the data for a source process
         * @summary Get preview events for source process
         * @param {BfSourceProcess} source Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewManagedEventsForSource(source: BfSourceProcess, options?: RawAxiosRequestConfig): AxiosPromise<Array<FeatureCollectionBfEvent>> {
            return localVarFp.getPreviewManagedEventsForSource(source, options).then((request) => request(axios, basePath));
        },
        /**
         * List source processes which can be managed
         * @summary List source processes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listManageableSources(options?: RawAxiosRequestConfig): AxiosPromise<Array<BfManagedSource>> {
            return localVarFp.listManageableSources(options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a managed event with the new definition
         * @summary Update a managed event
         * @param {BfManagedEvent} bfManagedEvent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManagedEvent(bfManagedEvent: BfManagedEvent, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.updateManagedEvent(bfManagedEvent, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ManagementApi - object-oriented interface
 */
export class ManagementApi extends BaseAPI {
    /**
     * Copies everything from the other event into the new managed event
     * @summary Create from another event, but copy it
     * @param {string} eHash Hash to copy from
     * @param {BfSourceProcess} destinationProcess Process which will own the event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createManagedEventCopy(eHash: string, destinationProcess: BfSourceProcess, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).createManagedEventCopy(eHash, destinationProcess, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Load the provided JSON as a managed event
     * @summary Create a managed event manually
     * @param {BfManagedEvent} bfManagedEvent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createManagedEventManual(bfManagedEvent: BfManagedEvent, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).createManagedEventManual(bfManagedEvent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Copies everything from the other event into the new managed event, and hide the original
     * @summary Create from another event, but mask it
     * @param {string} eHash Hash to copy from
     * @param {BfSourceProcess} sourceProcess Process which owns the event
     * @param {BfSourceProcess} destinationProcess Process which will own the event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createManagedEventMask(eHash: string, sourceProcess: BfSourceProcess, destinationProcess: BfSourceProcess, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).createManagedEventMask(eHash, sourceProcess, destinationProcess, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List events for a source process
     * @summary Events for source process
     * @param {BfSourceProcess} source Source process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public currentEventsForSource(source: BfSourceProcess, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).currentEventsForSource(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a managed event
     * @summary Remove a managed event
     * @param {string} eKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteManagedEvent(eKey: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).deleteManagedEvent(eKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List active events for a source process
     * @summary Active events for source process
     * @param {BfSourceProcess} source Source process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getActiveManagedEventsForSource(source: BfSourceProcess, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getActiveManagedEventsForSource(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current state of the managed event
     * @summary Get a managed event
     * @param {string} eKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getManagedEvent(eKey: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getManagedEvent(eKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List managed events for a source process
     * @summary Get managed events for source process
     * @param {BfSourceProcess} source Source process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getManagedEventsForSource(source: BfSourceProcess, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getManagedEventsForSource(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Preview the data for a source process
     * @summary Get preview events for source process
     * @param {BfSourceProcess} source Source process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPreviewManagedEventsForSource(source: BfSourceProcess, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getPreviewManagedEventsForSource(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List source processes which can be managed
     * @summary List source processes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listManageableSources(options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).listManageableSources(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a managed event with the new definition
     * @summary Update a managed event
     * @param {BfManagedEvent} bfManagedEvent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateManagedEvent(bfManagedEvent: BfManagedEvent, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).updateManagedEvent(bfManagedEvent, options).then((request) => request(this.axios, this.basePath));
    }
}

